import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { LocalApp, LocalAppLaunchMode } from '../../interfaces/local-app'
import { SmartAppService } from '../../services/smart-app.service'
import { AppGridWidget } from 'htv-lib'
import { PAGE_KEY } from '../../constants/page.constants'
import { BaseWidgetComponent } from '../base-widget/base-widget.component'
import { TranslateModule } from '@ngx-translate/core'
import { StateService } from '../../services/state.service'

@Component({
  selector: 'app-app-grid',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './app-grid.component.html',
  styleUrls: ['./app-grid.component.scss'],
})
export class AppGridComponent extends BaseWidgetComponent implements OnInit {
  localApps!: LocalApp[]
  selectedApp?: LocalApp

  constructor(
    private smartAppService: SmartAppService,
    private stateService: StateService
  ) {
    super()
  }

  override ngOnInit(): void {
    super.ngOnInit()

    this.localApps = this.smartAppService.localApps.filter(localApp => localApp.available)
  }

  override applyStyles(): void {
    super.applyStyles()

    const config = this.config as AppGridWidget
    const appCardStyle: Record<string, string | number> = {}
    const appCardInnerStyle: Record<string, string | number> = {}
    const appCardAppStyle: Record<string, string | number> = {}
    const appCardInnerSelectedStyle: Record<string, string | number> = {}
    const appCardAppSelectedStyle: Record<string, string | number> = {}

    if (config.nbColumns) {
      appCardStyle['width'] = `${100 / (config.nbColumns ?? 4)}%`
    }

    if (config.nbLines) {
      appCardStyle['height'] = `${100 / (config.nbLines ?? 4)}%`
    }

    if (config.gap) {
      appCardStyle['padding'] = `${this.scaleToResolution(config.gap / 2)}px`
    }

    if (config.itemBackgroundColor) {
      appCardAppStyle['background-color'] = config.itemBackgroundColor
    }

    if (config.focusBorderSize) {
      appCardInnerStyle['border-width'] = `${this.scaleToResolution(config.focusBorderSize)}px`
      appCardInnerSelectedStyle['border-width'] = `${this.scaleToResolution(config.focusBorderSize)}px`
    }

    if (config.focusBorderColor) {
      appCardInnerStyle['border-color'] = config.focusBorderColor
      appCardInnerSelectedStyle['border-color'] = config.focusBorderColor
    }

    if (config.focusBackgroundColor) {
      appCardAppSelectedStyle['background-color'] = config.focusBackgroundColor
    }

    this.setRule('.app-card', appCardStyle)
    this.setRule('.app-card__inner', appCardInnerStyle)
    this.setRule('.app-card__app', appCardAppStyle)
    this.setRule('.app-card.htv-selected .app-card__inner', appCardInnerSelectedStyle)
    this.setRule('.app-card.htv-selected .app-card__app', appCardAppSelectedStyle)
  }

  focusApp(app: LocalApp): void {
    this.selectedApp = app
    this.pageService.updateSubject(PAGE_KEY.SELECTED_APP, this.selectedApp)
  }

  openApp(app: LocalApp): void {
    this.smartAppService.launchApp(app.id, LocalAppLaunchMode.APPS)
  }

  focusClearData(): void {
    this.selectedApp = undefined
    this.pageService.updateSubject(PAGE_KEY.SELECTED_APP, this.selectedApp)
  }

  clearData(): void {
    this.stateService.clearGuestData()
  }
}
